<div *ngIf="isVisible" class="modal-overlay" (click)="close()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Marge Details - {{ selectedDate }}</h2>
      <button class="close-button" (click)="close()" aria-label="Sluiten">&times;</button>
    </div>

    <div class="modal-body">
      <!-- Loading State -->
      <div *ngIf="loading" class="loading-state">
        <div class="spinner"></div>
        <p>Gegevens laden...</p>
      </div>

      <!-- Error State -->
      <div *ngIf="error" class="error-state">
        <p>{{ error }}</p>
        <button class="retry-button" (click)="loadValuations(selectedDate)">Opnieuw</button>
      </div>

      <!-- Empty State -->
      <div *ngIf="!loading && !error && valuations.length === 0" class="empty-state">
        <p>Geen taxaties gevonden voor deze datum.</p>
      </div>

      <!-- Valuations Table -->
      <div *ngIf="!loading && !error && valuations.length > 0" class="table-container">
        <div class="summary-info">
          <p><strong>Totaal Taxaties:</strong> {{ valuations.length }}</p>
          <p><strong>Totale Marge:</strong> {{ formatCurrency(valuations.reduce((sum, v) => sum + v.marginActual, 0)) }}</p>
        </div>

        <table class="valuations-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Voertuig</th>
              <th>Inkoopprijs</th>
              <th>Verkoopprijs</th>
              <th>Marge</th>
              <th>Status</th>
              <th>Tijd</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let valuation of valuations; trackBy: trackByValuationId"
                [class.row-positive]="valuation.marginActual > 500"
                [class.row-low]="valuation.marginActual > 0 && valuation.marginActual <= 500"
                [class.row-negative]="valuation.marginActual < 0"
                (click)="openValuationDetail(valuation.id)">
              <td class="id-cell">{{ valuation.valuationNumber }}</td>
              <td class="vehicle-cell">{{ valuation.vehicleInfo }}</td>
              <td class="price-cell">{{ formatCurrency(valuation.dgwAmount) }}</td>
              <td class="price-cell">{{ formatCurrency(valuation.assignedPrice) }}</td>
              <td class="margin-cell" [ngClass]="getMarginClass(valuation.marginActual)">
                {{ formatMargin(valuation.marginActual) }}
              </td>
              <td class="status-cell">
                <span class="status-badge" [class.status-bought]="valuation.statusType === 'bought'">
                  {{ valuation.statusType }}
                </span>
              </td>
              <td class="time-cell">{{ valuation.marginDate | date:'HH:mm' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn-close" (click)="close()">Sluiten</button>
    </div>
  </div>
</div>
